import { logoutType } from '@Constants/User';

export default function logout() {
  return {
    type: logoutType,
  };
}
